import React, { useState, useEffect, useMemo } from 'react'
import { useNavigate } from 'react-router-dom';
import { getUserDetails } from '../../services/UserService';
import { AgGridReact } from 'ag-grid-react';
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-quartz.css";
import { pageSizes } from '../../utility/constants';
import {formatSixDigitNumber} from '../../services/CommonService';
import { toast } from 'react-toastify';
import Swal from 'sweetalert2'
import Loader from '../../utility/Loader';
import { getSurveyQuestion, deleteSurveyQuestion, getSurveyAnswers } from '../../services/Survey';

export default function ManageSurveys() {
    const [survey, setSurvey] = useState([]);
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const [userDetails, setUserDetails] = useState({user: {first_name: ""}});
    useEffect(() => {
        const userDetails = getUserDetails();
        if(userDetails.token === undefined){
          navigate('/login');
        }else{
          setUserDetails(userDetails);
          getAllSurveyData(userDetails.token);
        }
    },[]);

    const getAllSurveyData = async (token) => {
        setLoading(true);
        const surveyData = await getSurveyQuestion(token);
        if(surveyData.error){
            setSurvey([]);
        }else{
            let allSurvey = [];
            for(let i=0; i< surveyData.data.length; i++){
                let survey = Object.assign(surveyData.data[i]);
                if(survey.id !== 0){
                    survey['uid'] = "UID" + formatSixDigitNumber(survey.id);
                    survey['trigger'] = survey["course_name"] + " - " + survey["module_name"];
                    if(survey['type'] === 'RATING'){
                        survey['type_new'] = survey['type'] + " - "+survey['option1'] + " - "+survey['option2'];
                    }else{
                        survey['type_new'] = survey['type'];
                    }
                    allSurvey.push(survey);
                }

                
            }
            setSurvey(allSurvey);
        }
        setLoading(false);
    };

    const convertToCSV = (array) => {
          const headers = Object.keys(array[0]);
          const rows = array.map(obj => headers.map(field => JSON.stringify(obj[field] || "")).join(','));
          return [headers.join(','), ...rows].join('\n');
    };
      
    const handleDownload = (data) => {
        if(data.length > 0){
            const csvData = convertToCSV(data);
            const blob = new Blob([csvData], { type: 'text/csv;charset=utf-8;' });
            const url = URL.createObjectURL(blob);
        
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'survey_answers.csv');
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        }else{
            toast.info("No survey record found!");
        }
    };

    const [colDefs, setColDefs] = useState([
        {headerName: "Unique ID", field: "uid"},
        {headerName: "Survey Name", field: "survey_name"},
        {headerName: "Trigger", field: "trigger" },
        {headerName: "Type", field: "type_new" },

        {headerName: 'Status',
            valueGetter: (params) => {
                return params.data.status;
            },
            cellRenderer: params => {
                const onClick = () => {
                                    };
                return (
                    <>
                        <div onClick={onClick} className='cursor-pointer flex items-center h-full'>
                            {params.data.status === 'ACTIVE' ? (
                                <div className='active-status text-xs inter-500 leading-none bg-[#EBF9F1] text-[#1F9254] py-2 px-2 rounded-3xl'>Active</div>
                            ) : (
                                null
                            )}
                            {params.data.status === 'PENDING' ? (
                                <div className='suspend-status text-xs inter-500 leading-none bg-[#FEF2E5] text-[#CD6200] py-2 px-2 rounded-3xl'>Pending</div>
                            ) : (
                                null
                            )}
                            {params.data.status === 'CANCELLED' ? (
                                <div className='cancel-status text-xs inter-500 leading-none bg-[#FBE7E8] text-[#A30D11] py-2 px-2 rounded-3xl'>Cancelled</div>
                            ) : (
                                null
                            )}
                        </div>
                    </>
                );
            },
            sortable: true,
            filter: true
        },
        {headerName: 'Actions',
            cellRenderer: params => {
                const onClick = () => {
                    sessionStorage.setItem('updateSurvey', JSON.stringify(params.data));
                    navigate('/admin/createsurveys');
                };
                
                const onClickDelete = async () => {
                    Swal.fire({
                        title: 'Are you sure?',
                        text: "You won't be able to revert this!",
                        icon: 'warning',
                        showCancelButton: true,
                        confirmButtonText: 'Yes, delete it!',
                        cancelButtonText: 'No, cancel!',
                        reverseButtons: true
                    }).then(async (result) => {
                        if (result.isConfirmed) {
                            setLoading(true);
                            const userDtl = getUserDetails();
                            const surveyData = await deleteSurveyQuestion(userDtl.token, params.data.id);
                            if(!surveyData.error){
                                toast.success("Survey Deleted Successfully!");
                                await getAllSurveyData(userDtl.token);
                            }else{
                                toast.error("Some error occurred!");
                            }
                            setLoading(false);
                        } 
                    });
                    
                };

                const onClickDownload = async () => {
                    setLoading(true);
                    const userDtl = getUserDetails();
                    const surveyData = await getSurveyAnswers(userDtl.token, params.data.id);
                    if(!surveyData.error){
                        handleDownload(surveyData.data);
                    }else{
                        toast.error("Some error occurred!");
                    }
                    setLoading(false);
                };

                return (
                    <>
                        <div className='relative course-navigate-btns flex items-center justify-between h-full'>
                            <a onClick={onClickDownload} className='w-full md:w-max cursor-pointer bg-tertiary hover:bg-black flex items-center justify-center px-6 h-7 2xl:h-10 text-white inter-400 text-sm rounded-3xl lg:rounded-full transition duration-300 button-shadow'>Download</a>
                            <a onClick={onClick} className='cursor-pointer flex items-center justify-center transition duration-300'>
                                <svg xmlns="http://www.w3.org/2000/svg" width="25" height="24" viewBox="0 0 25 24" fill="none">
                                    <path d="M11.083 4H4.08301C3.55257 4 3.04387 4.21071 2.66879 4.58579C2.29372 4.96086 2.08301 5.46957 2.08301 6V20C2.08301 20.5304 2.29372 21.0391 2.66879 21.4142C3.04387 21.7893 3.55257 22 4.08301 22H18.083C18.6134 22 19.1221 21.7893 19.4972 21.4142C19.8723 21.0391 20.083 20.5304 20.083 20V13" stroke="#624DE3" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                    <path d="M18.583 2.49998C18.9808 2.10216 19.5204 1.87866 20.083 1.87866C20.6456 1.87866 21.1852 2.10216 21.583 2.49998C21.9808 2.89781 22.2043 3.43737 22.2043 3.99998C22.2043 4.56259 21.9808 5.10216 21.583 5.49998L12.083 15L8.08301 16L9.08301 12L18.583 2.49998Z" stroke="#624DE3" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                </svg>
                            </a>
                            <a onClick={onClickDelete} className='cursor-pointer flex items-center justify-center transition duration-300'>
                                <svg xmlns="http://www.w3.org/2000/svg" width="25" height="24" viewBox="0 0 25 24" fill="none">
                                    <path d="M3.08301 6H5.08301H21.083" stroke="#A30D11" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                    <path d="M8.08301 6V4C8.08301 3.46957 8.29372 2.96086 8.66879 2.58579C9.04387 2.21071 9.55257 2 10.083 2H14.083C14.6134 2 15.1221 2.21071 15.4972 2.58579C15.8723 2.96086 16.083 3.46957 16.083 4V6M19.083 6V20C19.083 20.5304 18.8723 21.0391 18.4972 21.4142C18.1221 21.7893 17.6134 22 17.083 22H7.08301C6.55257 22 6.04387 21.7893 5.66879 21.4142C5.29372 21.0391 5.08301 20.5304 5.08301 20V6H19.083Z" stroke="#A30D11" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                    <path d="M10.083 11V17" stroke="#A30D11" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                    <path d="M14.083 11V17" stroke="#A30D11" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                </svg>
                            </a>
                        </div>
                    </>
                );
            },
            
        }
    ]);
    const defaultColDef = useMemo(() => {
        return {
            filter: 'agTextColumnFilter',
            floatingFilter: true,
            flex: 1,
            minWidth: 200,
            maxWidth: 300,
        };
    }, []);
    return (
        <div>
            {loading ? (
                <Loader />
            ) : (
                <div className='py-10'>
                    <h3 className='text-2xl text-secondary inter-700 lg:hidden mb-6 px-6'>Manage Surveys</h3>
                    <div className='flex justify-end lg:mx-12 lg:px-0 px-6 pb-5 mb-6 border-b-2 border-[#D0D0D0]'>
                        <button onClick={() => navigate('/admin/createsurveys')} type="button" className='bg-secondary hover:bg-black flex items-center justify-center px-10 h-10 2xl:h-16 text-white inter-700 text-base 2xl:text-2xl rounded-3xl lg:rounded-full transition duration-300 button-shadow w-full md:w-auto'>+ Add New Survey</button>
                    </div>
                    <div className='lg:px-12 px-6'>
                        <div className="ag-theme-quartz" style={{ width: '100%', height: 500 }}>
                            <AgGridReact
                                rowData={survey}
                                columnDefs={colDefs}
                                defaultColDef={defaultColDef}
                                rowSelection="multiple"
                                suppressRowClickSelection={true}
                                pagination={true}
                                paginationPageSize={20}
                                paginationPageSizeSelector={pageSizes}
                            />
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}